import config from 'config';

export default (avatar) =>
  // Add timstamp for cache busting purposes
  `${
    config.avatarStoragePath
  }${avatar}?alt=media&token=${new Date().getTime()}`;
